import type { ReactNode, ReactElement } from 'react';

import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
// material
import { useTheme } from '@mui/material/styles';
import { Badge } from '@mui/material';

export interface MBadgeProps {
  children?: ReactNode;
  sx?: Record<string, any>;
  color?: string;
  [key: string]: any;
}

// ----------------------------------------------------------------------

const MBadge = forwardRef(function MBadgeImpl(
  { color = 'default', children, sx, ...other }: MBadgeProps,
  ref: ForwardedRef<HTMLElement>
) {
  const theme = useTheme();

  if (
    color === 'default' ||
    color === 'error' ||
    color === 'primary' ||
    color === 'secondary'
  ) {
    return (
      <Badge ref={ref} color={color} sx={sx} {...other}>
        {children}
      </Badge>
    );
  }

  return (
    <Badge
      ref={ref}
      sx={{
        '& .MuiBadge-badge': {
          color: theme.palette[color].contrastText,
          bgcolor: theme.palette[color].main,
        },
        ...sx,
      }}
      {...other}
    >
      {children}
    </Badge>
  );
});

export default MBadge;
